<template>
    <div class="dn-progress-bar">
        <div class="row box-bar">
            <div class="col-12 col-title" v-if="!!label">
                <h6>{{label}}</h6>
            </div>
            <div class="col col-info">
                <p class="f-w-500">
                    <slot name="reference">
                        {{Math.ceil(used)}} / {{Math.ceil(total)}} <small v-if="!!unit">{{unit}}</small>
                    </slot>
                </p>
            </div>

            <div class="col col-bar">
                <b-progress :value="Math.ceil(used)" :max="Math.ceil(total)"></b-progress>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DnProgress-bar',
    props: {
        unit: {
            type: String
        },
        label: {
            type: String
        },
        used: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    }
}
</script>